import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import UserPreferences from '@/services/UserPreferences';
import { ServiceState } from '@/entities/enums/ServiceState';
import CalibrationStatus from '@/entities/enums/CalibrationStatus';
import ApiQueriesKeys from '@/entities/enums/ApiQueriesKeys';
const PER_PAGE_OPTIONS = [10, 20, 30, 40, 50, 100];
let AdminCompanyLoggersComponent = class AdminCompanyLoggersComponent extends Vue {
    constructor() {
        super(...arguments);
        this.CalibrationStatus = CalibrationStatus;
        this.ServiceState = ServiceState;
        this.PER_PAGE_OPTIONS = PER_PAGE_OPTIONS;
        this.page = 1;
        this.pageSize = 20;
        this.sortDirection = UserPreferences.LocalStorageKeys.AdminCompanyLoggersSortDirection.defaultValue;
        this.sortField = UserPreferences.LocalStorageKeys.AdminCompanyLoggersSortField.defaultValue;
        this.totalSize = null;
        this.tableColumns = {
            loggerId: {
                field: 'loggerId',
                visible: UserPreferences.getPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersLoggerId)
            },
            macAddress: {
                field: 'macAddress',
                visible: UserPreferences.getPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersMacAddress)
            },
            serialNumber: {
                field: 'serialNumber',
                visible: UserPreferences.getPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersSerialNumber)
            },
            sourceName: {
                field: 'sourceName',
                visible: UserPreferences.getPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersSourceName)
            },
            lastSeen: {
                field: 'lastSeen',
                visible: UserPreferences.getPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersLastSeen)
            },
            calibration: {
                field: 'calibration',
                visible: UserPreferences.getPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersCalibration)
            },
            isOnline: {
                field: 'isOnline',
                visible: UserPreferences.getPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersIsOnline)
            },
            active: {
                field: 'active',
                visible: UserPreferences.getPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersActive)
            },
            battery: {
                field: 'battery',
                visible: UserPreferences.getPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersBattery)
            },
            expiration: {
                field: 'expiration',
                visible: UserPreferences.getPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersExpiration)
            }
        };
    }
    changedCompanyLoggers() {
        this.totalSize = this.companyLoggers.length;
    }
    get loggerList() {
        let loggerList = [];
        let deactivatedList = [];
        this.companyLoggers.forEach((logger) => {
            logger.source = this.sources.find((x) => x.logger && x.logger.macAddress === logger.macAddress);
            if (!logger.active)
                deactivatedList.push(logger);
            else
                loggerList.push(logger);
        });
        if (deactivatedList.length != 0)
            loggerList = loggerList.concat(deactivatedList);
        return loggerList;
    }
    get fromTableData() {
        let from = this.page == 1 ? this.page : (this.page - 1) * this.pageSize + 1;
        return from;
    }
    get toTableData() {
        return this.page * this.pageSize > this.totalSize ? this.totalSize : this.page * this.pageSize;
    }
    loggerDetail(loggerId) {
        this.$emit('loggerDetail', loggerId.toString());
    }
    onPageChange(page) {
        this.page = page;
        this.updateRouteQuery();
    }
    onSort(field, order) {
        this.sortField = field;
        this.sortDirection = order;
    }
    updateRouteQuery() {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries[ApiQueriesKeys.PAGE] = this.page;
        this.$router
            .replace({
            query: Object.assign({}, queries),
            params: this.$route.params
        })
            .catch((err) => { });
    }
    // changing default sort field
    changeDefaultSortField(sortFieldName) {
        if (this.sortField == sortFieldName) {
            this.sortField = this.tableColumns.serialNumber.field;
        }
    }
    chooseTableColumns(field, event) {
        switch (field) {
            case this.tableColumns.loggerId.field:
                if (!event) {
                    this.changeDefaultSortField(this.tableColumns.loggerId.field);
                }
                UserPreferences.setPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersLoggerId, event);
                break;
            case this.tableColumns.macAddress.field:
                if (!event) {
                    this.changeDefaultSortField(this.tableColumns.macAddress.field);
                }
                UserPreferences.setPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersMacAddress, event);
                break;
            case this.tableColumns.sourceName.field:
                if (!event) {
                    this.changeDefaultSortField('source.name');
                }
                UserPreferences.setPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersSourceName, event);
                break;
            case this.tableColumns.lastSeen.field:
                if (!event) {
                    this.changeDefaultSortField(this.tableColumns.lastSeen.field);
                }
                UserPreferences.setPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersLastSeen, event);
                break;
            case this.tableColumns.calibration.field:
                if (!event) {
                    this.changeDefaultSortField('calibration.status.name');
                }
                UserPreferences.setPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersCalibration, event);
                break;
            case this.tableColumns.expiration.field:
                if (!event) {
                    this.changeDefaultSortField('calibration.expiresAt');
                }
                UserPreferences.setPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersExpiration, event);
                break;
            case this.tableColumns.isOnline.field:
                if (!event) {
                    this.changeDefaultSortField(this.tableColumns.isOnline.field);
                }
                UserPreferences.setPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersIsOnline, event);
                break;
            case this.tableColumns.active.field:
                if (!event) {
                    this.changeDefaultSortField(this.tableColumns.active.field);
                }
                UserPreferences.setPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersActive, event);
                break;
            case this.tableColumns.battery.field:
                if (!event) {
                    this.changeDefaultSortField(this.tableColumns.loggerId.field);
                }
                UserPreferences.setPreference(UserPreferences.LocalStorageKeys.AdminCompanyLoggersBattery, event);
                break;
        }
        this.$nextTick(() => {
            this.$refs.table.initSort();
        });
    }
    downloadCalibration(id) {
        this.$emit('downloadCalibration', id);
    }
    hasCalibrationProtocolToDownload(logger) {
        return !(logger == null ||
            logger.calibration == null ||
            logger.calibration.calibratedAt <= 0 ||
            logger.calibration.notAvailable);
    }
};
__decorate([
    Prop({ type: Array })
], AdminCompanyLoggersComponent.prototype, "companyLoggers", void 0);
__decorate([
    Prop({ type: Object })
], AdminCompanyLoggersComponent.prototype, "dateTimeManager", void 0);
__decorate([
    Prop({ type: Object })
], AdminCompanyLoggersComponent.prototype, "company", void 0);
__decorate([
    Prop({ type: Array, default: [] })
], AdminCompanyLoggersComponent.prototype, "sources", void 0);
__decorate([
    Watch('companyLoggers')
], AdminCompanyLoggersComponent.prototype, "changedCompanyLoggers", null);
AdminCompanyLoggersComponent = __decorate([
    Component({})
], AdminCompanyLoggersComponent);
export default AdminCompanyLoggersComponent;
